
import React, { useState, useEffect, useRef } from "react";
import "./providerProfile.scss";
import UserImg from "../../assets/images/user.jpg";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { v4 as uuidv4 } from "uuid";
import {
  convertHourToDate,
  defaultShifts,
  getFullName,
} from "../../utils/common";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import sha256 from "js-sha256";

// import ReactDatePicker from 'react-datepicker';
import {
  GoogleMap,
  LoadScript,
  Marker,
  StandaloneSearchBox,
  DirectionsRenderer,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";

import {
  CallIcon,
  EditIcon,
  EmailIcon,
  LocationIcon,
  PasswordIcon,
  StarOutline,
  UserIcon,
  ClockIcon,
  SheildIcon,
  DollorIcon,
  ServicesIcon,
  DeleteIcon,
} from "../../components/Icons";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import { Delete } from "react-iconly";
import {
  login,
  updateAvailability,
  provider_getProfile,
  updateProfile,
  getService,
  ChangePassword,
  deleteService,
  updateAvailabilityTiming,
  saveGoogleAccessToken,
  saveOutlookAccessToken,
  fetchBankDetailsStatus,
  serviceImageUpload,
  serviceImageRemove,
} from "../../services/auth.service";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TimePicker from "react-time-picker";
import ReactDatePicker from "react-datepicker";
import { GOOGLE_MAPS_API_KEY, toast_success } from "../../config/Constant";
import "react-time-picker/dist/TimePicker.css";
import StarRating from "../../components/rating/StarRating";
import { setLoader, isLoading } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";
import { selectUser } from "../../slice/authSlice";
import { Container } from "react-bootstrap";
import ImageUpload from "../userProfile/accountSetting/ImageUpload";
import { apiUrl } from "../../environment";

const ProviderProfile = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const signIn = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/calendar.readonly",
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      handleAccessToken(codeResponse?.code);
    },
  });
  let navigate = useNavigate();
  const [providerData, setProviderData] = useState({});
  const [changePassword, setChangePassword] = useState({});

  const [services, setServices] = useState();
  const [image1, setImage1] = useState(null);
  const [resetKey, setResetKey] = useState(0);
  const [isToggled, setIsToggled] = useState(true);

  const [serviceName, setsetServiceName] = useState([]);

  // const [loading, setLoading] = useState(true);
  const [selectedTime, setSelectedTime] = useState(new Date());

  const [availability, setAvailability] = useState();
  const [syncGoogle, setSyncGoogle] = useState(false);
  const [syncOutlook, setSyncOutlook] = useState(false);
  const inputRef = useRef(null);

  // const [value, onChange] = useState(new Date());
  const [time, setTime] = useState("10:00");
  const [tokens, setTokens] = useState(null);
  const { instance, accounts, inProgress } = useMsal();
  const { code } = useParams();
  const [days, setDays] = useState([]);

  const [resetImages, setResetImages] = useState(false);
  const [serviceImages, setServiceImages] = useState([]);

  useEffect(() => {
    // console.log();
    // Ensure that the MSAL instance is configured with redirect handlers
    instance.handleRedirectPromise().then((response) => {
      // Handle the authentication response if needed
    });
  }, [instance]);
  useEffect(() => {
    // Use the 'code' value as needed
    // Your logic to handle the authorization code
    // Optionally, you might want to redirect the user or perform other actions
  }, [code]);
  const startRef = useRef();
  const libraries = ["places"];
  const mapOptions = {
    disableDefaultUI: true,
  };
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const onChange = (value) => {
    setTime(value);
  };

  const [servicesList, setServicesList] = useState([
    {
      id: uuidv4(), // You need to import uuidv4 from 'uuid' or use any other unique ID generation method
      service: "",
      rate: "",
    },
  ]);

  const [timeData, setTimeData] = useState();

  const changePasswordHandle = async () => {
    try {
      const response = await ChangePassword(changePassword);
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setResetKey((prevKey) => prevKey + 1);
      } else {
        toast.warning(response.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (e) {
      console.log(e, "catch");
      // toast.warning(response.message, {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    }
  };

  const handleToggleDay = (index) => {
    const newDays = [...days];
    newDays[index].available = !newDays[index].available;
    setDays(newDays);
  };

  const handleTimeChange = (time, index, type) => {
    const newDays = [...days];
    newDays[index][type] = time;
    // Add validation message
    if (
      type === "startTime" &&
      newDays[index].endTime &&
      time >= newDays[index].endTime
    ) {
      toast.warning("Start time should be less than end time.", {
        position: toast.POSITION.TOP_CENTER,
      });

      // toast_warning("Start time should be less than end time.");
      return;
    }

    if (
      type === "endTime" &&
      newDays[index].startTime &&
      time <= newDays[index].startTime
    ) {
      toast.warning("End time should be greater than start time.", {
        position: toast.POSITION.TOP_CENTER,
      });

      // toast_warning("Start time should be less than end time.");
      return;
    }
    setDays(newDays);
  };

  const handleScheduleSubmit = async () => {
    // console.log("hit---")
    try {
      await dispatch(setLoader(true));
      const updatedShifts = days.map((day) => ({
        dayOfWeek: day.dayOfWeek,
        available: day.available,
        _id: day._id,
        // Convert startTime and endTime Date objects to hours using getHours()
        startTime: day.startTime ? new Date(day.startTime).getHours() : null,
        endTime: day.endTime ? new Date(day.endTime).getHours() : null,
      }));
      const response = await updateAvailabilityTiming(updatedShifts);
      await dispatch(setLoader(false));
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchProfileData();
      } else {
        toast.warning(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  const transformShiftsForState = (shiftsFromBackend) => {
    return defaultShifts.map((defaultShift) => {
      const foundShift = shiftsFromBackend.find(
        (s) => s.dayOfWeek === defaultShift.dayOfWeek
      );
      // console.log("foundshift", foundShift)
      if (foundShift) {
        return {
          ...foundShift,
          startTime: foundShift.startTime
            ? convertHourToDate(foundShift.startTime, new Date())
            : null,
          endTime: foundShift.endTime
            ? convertHourToDate(foundShift.endTime, new Date())
            : null,
        };
      }
      return defaultShift;
    });
  };

  //   useEffect(() => {
  //     fetchData();
  //     console.log(service,"all the serive")
  // }, [fetchData]);
  // **********************************getdata start********************************************************************
  const fetchProfileData = async () => {
    try {
      await dispatch(setLoader(true));
      const response = await provider_getProfile();
      setServices(response.data.services);
      let startDate = new Date(response.data.provider.shiftStartTime);
      let endDate = new Date(response.data.provider.shiftEndTime);
      // Get the current date
      let currentDate = new Date();
      setDays(transformShiftsForState(response?.data?.provider?.shifts));
      // Set the hours and minutes based on the shift start time
      let datestart = currentDate.setHours(
        response?.data?.provider?.shiftStartTime,
        0,
        0,
        0
      );
      let dateend = currentDate.setHours(
        response?.data?.provider?.shiftEndTime,
        0,
        0,
        0
      );
      // Now currentDate contains the current date with the specified shift start time
      setAvailability(response?.data?.provider?.isAvailable);
      setSyncGoogle(response?.data?.provider?.syncGoogleCalendar);
      setSyncOutlook(response?.data?.provider?.syncOutlookCalendar);
      let objs = {
        name:
          response?.data?.provider?.firstName +
          " " +
          response?.data?.provider?.lastName,
        email: response?.data?.provider?.email,
        phone: response?.data?.provider?.phone,
        bio: response?.data?.provider?.bio,
        location: response?.data?.provider?.location,
        policyText: response?.data?.policyText,
        // cancellationPolicy: response.data.policyText,
        cancellationPolicy:
          response?.data?.policyText ===
          "Cancel before 48 hours at no charge (Strict)"
            ? 48
            : response?.data?.policyText ===
              "Cancel before 12 hours at no charge (Moderate)"
            ? 12
            : response?.data?.policyText ===
              "Cancel anytime before the job has started at no charge (Flexible)"
            ? 0
            : "",

        policy: response?.data?.policyText,

        services: response?.data?.services[0]?.serviceId,
        services_rate: response?.data?.services[0]?.rate,
        profilePic: response?.data?.provider?.profilePic,
        shiftStartTime: response?.data?.provider?.shiftStartTime,
        shiftEndTime: response?.data?.provider?.shiftEndTime,
        showStartTime: new Date(datestart),
        showEndTime: new Date(dateend),
        ratingProvider: response?.data?.provider?.ratingProvider,
        baseUrl: "https://helpr.bm:8001/",
      };
      // console.log("before object");
      // console.log("object==>", objs);
      setProviderData(objs); // Use response.data to access the data
      let timeObj = {
        // startTime: new Date(response?.data?.provider?.shiftStartTime),
        // endTime: new Date(response?.data?.provider?.shiftEndTime),
        startTime: new Date(datestart),
        endTime: new Date(dateend),
      };
      setTimeData(timeObj);
      // console.log("settimeobg==>", timeData);
      // setLoading(false);
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error fetching profile data:", error);
      // setLoading(false);
      await dispatch(setLoader(false));
    }
  };

  const fetchService = async () => {
    const data = await getService();
    // console.log("data==>", data);
    setsetServiceName(data.data.services);
  };
  useEffect(() => {
    // Fetch provider profile data from the API

    fetchService();
    fetchProfileData();
  }, []);

  // if (loading) {
  //   return <p>Loading...</p>;
  // }

  // **************************************get data end****************************************************************
  const handleAvailabilityToggle = async () => {
    try {
      // Make the API call to update the availability status
      const response = await updateAvailability(!availability);
      // console.log("Availability Updated:ajay", response.data);

      setAvailability(!availability);
      if (response?.data?.status === true) {
        // console.log("ajajjjaja");
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        // console.log("ajajjjaja else");
        toast.warning(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error("Error updating availability:", error);
    }
  };

  // ************************************updateAvailability end******************************************************************
  // Function to handle the update profile button click
  // ... (previous code)
  const handleAddService = () => {
    // Add a new empty service to the state
    setServices([
      ...services,
      {
        _id: "",
        serviceId: "",
        rate: 0,
      },
    ]);
    // console.log(services, "inside");
  };

  const handleDeleteService = async (index, serviceId) => {
    // console.log(index, serviceId, "handleDeleteService");
    const updatedServices = [...services];
    updatedServices.splice(index, 1);
    // console.log(updatedServices, "after deletation");
    setServices(updatedServices);
    const idToDelete = [{ _id: serviceId }];
    const result = await deleteService(idToDelete);
    // console.log("result===>", result);
    fetchProfileData();
  };

  const handleServiceChange = (index, field, value) => {
    // Update the specified field of the service at the specified index
    // console.log("index=>", index, "field=>", field, "value=>", value);
    const updatedServices = [...services];
    // console.log(updatedServices, "updatedServices");
    updatedServices[index][field] = value;
    // console.log(updatedServices, "after updatedServices");
    setServices(updatedServices);
  };
  // Function to handle the update profile button click
  const handleUpdateProfile = async () => {
    // console.log(services, "servicesservices");
    // Check if any service is not selected or price is not provided
    const isServiceNotSelected = services.some((service) => !service.serviceId);
    const isPriceNotProvided = services.some((service) => !service.rate);

    if (isServiceNotSelected && isPriceNotProvided) {
      toast.error(
        "Please select a service and provide a price for each service."
      );
      return;
    } else if (isServiceNotSelected) {
      toast.error("Please select a service for each service.");
      return;
    } else if (isPriceNotProvided) {
      toast.error("Please provide a price for each service.");
      return;
    }

    // Check for duplicate services
    const serviceIds = new Set();
    const duplicateService = services.some((service) => {
      // Check if serviceId is an object or a string
      const serviceId =
        typeof service.serviceId === "object"
          ? service.serviceId._id
          : service.serviceId;
      if (serviceIds.has(serviceId)) {
        return true; // Duplicate service found
      }
      serviceIds.add(serviceId);
      return false;
    });

    if (duplicateService) {
      toast.error("Duplicate services are not allowed.");
      return;
    }

    const restructuredData = services.map((item) => ({
      _id: item._id,
      serviceId:
        toString.call(item.serviceId) == "[object String]"
          ? item?.serviceId
          : item?.serviceId?._id,
      rate: item.rate,
    }));
    let serv = JSON.stringify(restructuredData);
    // console.log(providerData, "provider data sneidng");
    try {
      await dispatch(setLoader(true));
      const formData = new FormData();
      formData.append("name", providerData.name);
      formData.append("email", providerData.email);
      formData.append("phone", providerData.phone);
      formData.append("bio", providerData.bio);
      formData.append("location", providerData.location);
      formData.append("cancellationPolicy", providerData.cancellationPolicy);
      // formData.append("shiftStartTime", providerData.shiftStartTime);
      // formData.append("shiftEndTime", providerData.shiftEndTime);

      // Convert services to JSON string and append to formData
      formData.append("services", JSON.stringify(restructuredData));

      // Append the profilePic only if it's a File object
      if (providerData.profilePic instanceof File) {
        formData.append("profilePic", providerData.profilePic);
      }

      const response = await updateProfile(formData);

      // console.log("Profile Updated:", response.data);

      // Handle success or show a toast message
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchProfileData();
      } else {
        toast.warning(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error updating profile:", error);
      await dispatch(setLoader(false));
    }
  };

  // ... (remaining code)

  // Function to handle changes in form fields
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setProviderData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDatePickerChange = (date, fieldName) => {
    setTimeData((prevData) => ({
      ...prevData,
      [fieldName]: new Date(date),
    }));
    let timeToSendStartDate;
    let timeToSendEndDate;
    if (fieldName === "startTime") {
      timeToSendStartDate = date.getHours();
    } else {
      timeToSendEndDate = date.getHours();
    }
    // Call your function with the payload
    const payload = {
      startTime: timeToSendStartDate
        ? timeToSendStartDate
        : timeData.startTime.getHours(),
      endTime: timeToSendEndDate
        ? timeToSendEndDate
        : timeData.endTime.getHours(),
    };
    // console.log("Time in hour", timeToSendStartDate, timeToSendEndDate);
    // console.log("payloadImp==>", payload);
    yourFunctionToHandlePayload(payload);
  };

  const yourFunctionToHandlePayload = async (payload) => {
    const { startTime, endTime } = payload;

    const payload1 = {
      startTime,
      endTime,
    };
    // console.log("Payload==>", payload1);
    const result = await updateAvailabilityTiming(payload1);
    // console.log("updateAvailabilityTiming", result);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    setChangePassword((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    // console.log("e.target.files[0]", e.target.files[0]);
    setProviderData((previous) => ({
      ...previous,
      profilePic: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage1(e.target.result);
        // console.log(image1, "image1");
      };
      reader.readAsDataURL(file);
    }
  };
  // const handleRadioChange = (event) => {
  //   if(event.target.value == 48){
  //     // setProviderData.policy = "Cancel before 48 hours at no charge"
  //     console.log(providerData,"48hr")
  //     setProviderData((previousData) => ({
  //       ...previousData,
  //       policy: "Cancel before 48 hours at no charge",
  //     }));

  //   }
  //    if(event.target.value == 12){
  //     // setProviderData.policy = "Cancel before 12 hours at no charge"
  //     console.log(providerData,"12hr")
  //     setProviderData({
  //       ...providerData,
  //       policy: "Cancel before 12 hours at no charge"
  //     });

  //   }else{
  //     //  setProviderData.policy = "Cancel anytime before the job has started at no charge"
  //     console.log(providerData,"0hr")
  //     setProviderData({
  //       ...providerData,
  //       policy: "Cancel anytime before the job has started at no charge"
  //     });

  //   }
  //   setProviderData({
  //     ...providerData,
  //     cancellationPolicy: event.target.value,
  //   });
  // };
  const handleRadioChange = (event) => {
    let updatedPolicy = "";

    if (event.target.value === "48") {
      updatedPolicy = "Cancel before 48 hours at no charge (Strict)";
    } else if (event.target.value === "12") {
      updatedPolicy = "Cancel before 12 hours at no charge (Moderate)";
    } else {
      updatedPolicy =
        "Cancel anytime before the job has started at no charge (Flexible)";
    }

    setProviderData((previousData) => ({
      ...previousData,
      policy: updatedPolicy,
      cancellationPolicy: event.target.value,
    }));
  };

  // console.log(providerData, "48hr");
  const generateImageUrl = (imagePath) => {
    return `https://helpr.bm:9210/` + `${imagePath}`;
  };

  const handlePlaceChangedStart = () => {
    if (startRef.current) {
      const places = startRef.current.getPlaces();
      if (places.length > 0) {
        const locationName = places[0].name;
        setProviderData((previousData) => ({
          ...previousData,
          location: locationName,
        }));

        // Update the input value using the ref
        if (inputRef.current) {
          inputRef.current.value = locationName;
        }
      }
    }
  };
  const deleteservice = async () => {
    let payload = [];
    // console.log("PayloadDelete==>", payload);
    // const result = await deleteService(payload);
    // console.log(result);
  };
  // *********************************Update profile data end************************************************************************************
  const handleSwitchChange = async (value) => {
    // setAvailability((prevChecked) => !prevChecked);
    const requestBody = {
      isAvailable: value, // Toggle the current state
    };
    try {
      await dispatch(setLoader(true));
      const bankResponse = await fetchBankDetailsStatus();
      if (bankResponse?.data?.status || user?.marketingEmail !== null) {
        const response = await updateAvailability(requestBody);
        // setAvailability(!value);
        setAvailability((prevChecked) => !prevChecked);
        if (response?.data?.status === true) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          fetchProfileData();
        } else {
          toast.warning(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        toast.warning(bankResponse?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error updating availability:", error);
      await dispatch(setLoader(false));
    }
  };

  const handleAccessToken = (token) => {
    if (token) {
      let payload = {
        code: token,
        status: true,
      };
      handleUpdateGoogleSync(payload, true);
    }
  };

  const handleUpdateGoogleSync = async (payload, status) => {
    await dispatch(setLoader(true));
    try {
      const response = await saveGoogleAccessToken(payload);
      if (response?.data?.status) {
        setSyncGoogle(status);
      }
      toast.success(response?.data?.message, toast_success);
      await dispatch(setLoader(false));
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  };

  const handleUpdateOutlookSync = async (payload, status) => {
    await dispatch(setLoader(true));
    try {
      const response = await saveOutlookAccessToken(payload);
      if (response?.data?.status) {
        setSyncOutlook(status);
        if (!status) {
          instance.logoutPopup();
        }
      }
      toast.success(response?.data?.message, toast_success);
      await dispatch(setLoader(false));
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  };

  const handleSyncGoogle = (status) => {
    if (status) {
      signIn();
    } else {
      let payload = {
        status: false,
      };
      handleUpdateGoogleSync(payload, false);
    }
  };

  const handleSyncOutlook = (status) => {
    if (status) {
      handleSyncOutlookLogin();
    } else {
      let payload = {
        status: false,
      };
      handleUpdateOutlookSync(payload, false);
    }
  };

  const handleSyncOutlookLogin = async () => {
    const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
    const authority = "https://login.microsoftonline.com/consumers";
    const redirectUri = encodeURIComponent(
      process.env.REACT_APP_MICROSOFT_REDIRECT_URL
    );
    const responseType = "code";
    const responseMode = "query";
    const scopes = ["openid", "profile", "Calendars.Read", "offline_access"];
    const state = "12345";
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = generateCodeChallenge(codeVerifier);
    try {
      const authorizationUrl = `${authority}/oauth2/v2.0/authorize`;
      const scopeString = encodeURIComponent(scopes.join(" "));

      const authorizationRequestUrl = `${authorizationUrl}?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&response_mode=${responseMode}&scope=${scopeString}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

      // Open the authorization URL in a popup
      const popup = window.open(
        authorizationRequestUrl,
        "Authorization Popup",
        "width=600,height=600"
      );

      let authorizationCodeLogged = false;

      // Check for changes in the popup window's location
      const checkPopupStatus = setInterval(() => {
        try {
          const popupUrl = popup.location.href;

          if (
            popupUrl.startsWith(process.env.REACT_APP_MICROSOFT_REDIRECT_URL) &&
            !authorizationCodeLogged
          ) {
            // Extract the authorization code from the URL
            const urlSearchParams = new URLSearchParams(popupUrl.split("?")[1]);
            const authorizationCode = urlSearchParams.get("code");
            authorizationCodeLogged = true;

            // Close the popup window or perform additional actions as needed
            let payload = {
              status: true,
              code: authorizationCode,
              codeChallenge: codeVerifier,
              redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URL,
              type: "web",
            };
            handleUpdateOutlookSync(payload, true);
            popup.close();
            clearInterval(checkPopupStatus);
          }
        } catch (error) {
          // Ignore cross-origin errors
        }
      }, 1000); // Adjust the interval as needed
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const generateCodeVerifier = () => {
    // Generate a random string for codeVerifier (at least 43 characters)
    const codeVerifier = [...Array(64)]
      .map(() => (~~(Math.random() * 36)).toString(36))
      .join("");

    return codeVerifier;
  };

  const generateCodeChallenge = (codeVerifier) => {
    // Hash the codeVerifier using SHA-256
    const codeChallenge = sha256.arrayBuffer(
      new TextEncoder().encode(codeVerifier)
    );

    // Encode the hash as a URL-safe base64 string
    const codeChallengeEncoded = base64URLEncode(codeChallenge);

    return codeChallengeEncoded;
  };

  const base64URLEncode = (arrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(null, bytes))
      .replace("+", "-")
      .replace("/", "_")
      .replace(/=+$/, "");
  };

  const submitServiceImg = async (index, services) => {
    if (!serviceImages[index]) {
      toast.error("No images selected!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    await dispatch(setLoader(true));

    const formdata = new FormData();
    serviceImages[index].forEach((image) => {
      formdata.append(`serviceImages`, image);
    });

    try {
      const uploadImg = await serviceImageUpload(formdata);
      await dispatch(setLoader(false));

      if (uploadImg?.data?.status) {
        setServices((prevServices) => {
          const updatedServices = [...prevServices];
          const serviceToUpdate = { ...updatedServices[index] };
          serviceToUpdate.images = uploadImg.data.uploadedImages;

          // If you want to add all uploaded images to the existing images array:
          if (
            prevServices[index].images &&
            Array.isArray(prevServices[index].images)
          ) {
            prevServices[index].images.forEach((image) => {
              serviceToUpdate.images.push(image);
            });
          }

          updatedServices[index] = serviceToUpdate;
          handleUpdateProfileimg(updatedServices);
          setServiceImages([]);

          return updatedServices;
        });
      } else {
        toast.error("Unable to upload images!", {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error uploading images:", error);
    }
  };

  const removeImg = async (image, index) => {
    let arr = [image];
    const result = await serviceImageRemove({ imageNames: arr });
    setServices((prevServices) => {
      const updatedServices = [...prevServices];
      const serviceToUpdate = { ...updatedServices[index] };

      // Remove the image from serviceToUpdate.images array
      serviceToUpdate.images = serviceToUpdate.images.filter(
        (img) => img !== image
      );
      updatedServices[index] = serviceToUpdate;
      handleUpdateProfileimg(updatedServices);
      setServiceImages([]);
      return updatedServices;
    });
  };

  const handleUpdateProfileimg = async (updatedServices) => {
    const restructuredData = updatedServices.map((item) => ({
      images: item.images,
      _id: item._id,
      serviceId:
        toString.call(item.serviceId) === "[object String]"
          ? item?.serviceId
          : item?.serviceId?._id,
      rate: item.rate,
    }));
    try {
      const formData = new FormData();
      formData.append("name", providerData.name);
      formData.append("email", providerData.email);
      formData.append("phone", providerData.phone);
      formData.append("bio", providerData.bio);
      formData.append("location", providerData.location);
      formData.append("cancellationPolicy", providerData.cancellationPolicy);
      formData.append("services", JSON.stringify(restructuredData));

      if (providerData.profilePic instanceof File) {
        formData.append("profilePic", providerData.profilePic);
      }
      const response = await updateProfile(formData);
      if (response?.data?.status === true) {
        setResetImages(true);
      }

      fetchProfileData();
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleImagesReset = () => {
    setResetImages(false); // Reset resetImages back to false
  };

  const handleServiceImages = (index, images) => {
    setServiceImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = images;
      return updatedImages;
    });
  };

  return (
    <>
      <Header />
      <PageHeading title="Profile" />

      <div className="main-container">
        <div className="container-wrap">
          <div className="provider-setting-wrap">
            <div className="box-wrapper">
              <div className="provider-wrapper">
                <div className="provider-info-wrap">
                  <div className="provider-info-title">
                    Account setting
                    <div className="availability-row">
                      <div className="availability">
                        <i>
                          <UserIcon />
                        </i>{" "}
                        <span>Availability</span>
                      </div>
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        checked={availability}
                        // onChange={(e) => setAvailability(e.target.checked)}
                        // onChange={handleSwitchChange}
                        onChange={(e) => {
                          handleSwitchChange(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                  <div className="user-provider-detail-top">
                    <div className="user-img-wrap">
                      <div className="user-pic">
                        <img src={generateImageUrl(providerData?.profilePic)} />
                      </div>
                      {/* <div className="edit-pic">
                        <EditIcon />
                      </div> */}
                      <div>
                        <label htmlFor="fileInput" className="edit-pic">
                          <EditIcon />
                        </label>
                        <input
                          id="fileInput"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>
                    <div className="user-name-wrap">
                      <div className="username">{providerData?.name}</div>
                      <div className="user-rating-wrap">
                        <div className="rating">
                          <StarRating
                            value={
                              providerData?.ratingProvider
                                ? providerData?.ratingProvider
                                : 0
                            }
                          />
                        </div>
                        <div className="view-rating">
                          (
                          {providerData?.ratingProvider
                            ? providerData?.ratingProvider
                            : 0}
                          ) -{" "}
                          <span
                            onClick={() => navigate("/provider/viewrating")}
                          >
                            View Ratings
                          </span>
                        </div>
                      </div>
                    </div>
`1  `                    <div className="edit-btn-wrap">
                      <Button variant="primary" onClick={signIn}>
                        Sync Google Calender
                      </Button>
                    </div>
                    <div className="edit-btn-wrap">
                      <Button variant="primary" onClick={handleUpdateProfile}>
                        Update Profile
                      </Button>
                    </div>
                  </div>
                  <Form className="update-profile">
                    <Row>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <UserIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Full Name"
                              name="name"
                              value={providerData?.name}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <EmailIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Email address"
                              name="email"
                              value={providerData?.email}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <CallIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                              name="phone"
                              value={providerData?.phone}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      {/* <Col lg={6}>
                        <Row>
                          <Col sm={6}>
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <ClockIcon />
                              </div>
                              <Form.Group
                                className="mb-3"
                                controlId="startTime"
                              >
                                <Form.Label>Start Time</Form.Label>
                               
                                <ReactDatePicker
                                  className="form-control"
                                  selected={timeData?.startTime}
                                  onChange={(date) =>
                                    handleDatePickerChange(date, "startTime")
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <ClockIcon />
                              </div>

                              <Form.Group className="mb-3" controlId="endTime">
                                <Form.Label>End Time</Form.Label>
                                <ReactDatePicker
                                  className="form-control"
                                  selected={timeData?.endTime}
                                  onChange={(date) =>
                                    handleDatePickerChange(date, "endTime")
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                />
                              </Form.Group>
                            
                            </div>
                          </Col>
                        </Row>
                      </Col> */}
                      {/* <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <ClockIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="shiftTime">
                            <Form.Label>Shift Timing</Form.Label>
                            <Form.Control
                              type="text"
                              name="shiftTiming"
                              placeholder="Shift Timing"
                              onChange={handleFormChange}
                              value={providerData.shiftTiming}
                            />
                          </Form.Group>
                        </div>
                      </Col> */}
                      {/* <Col lg={12}>
                        <div className="input-wrap canclelation">
                          <div className="icon-wrap">
                            <SheildIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="location">
                            <Form.Control
                              type="text"
                              placeholder="Cancelation Policy"
                              value={providerData.policyText}
                            />
                          </Form.Group>
                        </div>
                      </Col> */}

                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <LocationIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="bio">
                            <Form.Label>Bio</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="bio"
                              value={providerData?.bio}
                              onChange={handleFormChange}
                              children={null} // Add this line to remove default text content
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <LocationIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="location">
                            <Form.Label>Location</Form.Label>
                            {isLoaded ? (
                              <StandaloneSearchBox
                                onLoad={(ref) => (startRef.current = ref)}
                                onPlacesChanged={handlePlaceChangedStart}
                              >
                                <Form.Control
                                  type="text"
                                  name="location"
                                  defaultValue={providerData?.location}
                                  ref={inputRef}
                                />
                              </StandaloneSearchBox>
                            ) : null}
                          </Form.Group>
                        </div>
                      </Col>
                      {services?.map((service, index) => (
                        <div key={index} className="add-service-container">
                          <div className="add-row-wrap">
                            <div className="add-content">
                              <Row>
                                {/* <Col sm={6} className="mb-3 mb-sm-0"> */}
                                <Col sm={6}>
                                  <div className="input-wrap">
                                    <div className="icon-wrap">
                                      <ServicesIcon />
                                    </div>
                                    <Form.Label>Add Services</Form.Label>
                                    <Form.Select
                                      className="mb-3"
                                      value={service?.serviceId?._id}
                                      name={service?.serviceId?.name}
                                      onChange={(e) =>
                                        handleServiceChange(
                                          index,
                                          "serviceId",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="" disabled selected>
                                        Please Select Service
                                      </option>
                                      {serviceName?.map((item) => (
                                        <option
                                          key={item?.name}
                                          value={item?._id}
                                        >
                                          {item?.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="input-wrap">
                                    <div className="icon-wrap">
                                      <DollorIcon />
                                    </div>
                                    <Form.Group>
                                      <Form.Label>Hourly Rate</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="rate"
                                        placeholder="Hourly Rate"
                                        value={service?.rate}
                                        onChange={(e) =>
                                          handleServiceChange(
                                            index,
                                            "rate",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                </Col>
                                <Row>
                                  {!service?.serviceId && (
                                    <Col sm={6}>
                                      <span className="error-message">
                                        Please select a service.
                                      </span>
                                    </Col>
                                  )}
                                  {(!service?.rate || isNaN(service?.rate)) && (
                                    <Col sm={6}>
                                      <span className="error-message">
                                        Please provide a valid price (numbers
                                        only).
                                      </span>
                                    </Col>
                                  )}
                                </Row>
                              </Row>
                              <div className="service-images">
                                <div className="uploaded-images">
                                  {service?.images?.map((image, imgIndex) => (
                                    <div
                                      key={imgIndex}
                                      className="image-container"
                                    >
                                      <img
                                        src={`${apiUrl}${image}`}
                                        alt={`Service ${index + 1} Image ${
                                          imgIndex + 1
                                        }`}
                                        className="service-image"
                                        style={{
                                          maxWidth: "100px",
                                          maxHeight: "100px",
                                        }}
                                      />

                                      <div
                                        className="delete-icon"
                                        onClick={() => removeImg(image, index)}
                                      >
                                        <DeleteIcon />
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <div className="added-images">
                                  <ImageUpload
                                    maxImages={5 - service?.images?.length}
                                    index={index}
                                    handleServiceImages={handleServiceImages}
                                    resetImages={resetImages}
                                    handleImagesReset={handleImagesReset}
                                  />
                                </div>
                              </div>

                              <Row className="justify-content-between">
                                <Col sm={3} className="ms-auto upload-btn">
                                  <span
                                    className="image-upload-label"
                                    onClick={() =>
                                      submitServiceImg(index, service)
                                    }
                                  >
                                    Upload Images
                                  </span>
                                </Col>
                                {/* <Col sm={3}>
                              </Col> */}
                              </Row>
                              <br />
                            </div>
                            <div
                              className="delete-icon"
                              onClick={() =>
                                handleDeleteService(index, service?._id)
                              }
                            >
                              <DeleteIcon />
                            </div>
                          </div>
                        </div>
                      ))}
                      <Col md={12} className="mb-4 mt-2">
                        <span
                          className="add-service-link"
                          onClick={handleAddService}
                        >
                          + Add more services
                        </span>
                      </Col>
                      <Col md={12}>
                        <div className="box-wrapper">
                          <div className="input-wrap">
                            <div className="icon-wrap">
                              <SheildIcon />
                            </div>
                            <label className="form-label">
                              Cancelation Policy
                            </label>
                            <div className="form-control">
                              <Form.Check
                                type="radio"
                                label="Cancel before 48 at no charge"
                                value="48"
                                name="radioGroup"
                                id="option1"
                                checked={
                                  providerData?.policy ===
                                  "Cancel before 48 hours at no charge (Strict)"
                                }
                                onMouseUp={handleRadioChange}
                              />
                              <Form.Check
                                type="radio"
                                label="Cancel before 12 at no charge"
                                value="12"
                                name="radioGroup"
                                id="option2"
                                checked={
                                  providerData?.policy ===
                                  "Cancel before 12 hours at no charge (Moderate)"
                                }
                                onMouseUp={handleRadioChange}
                              />
                              <Form.Check
                                type="radio"
                                label="Cancel anytime at no charge"
                                value="0"
                                name="radioGroup"
                                id="option3"
                                checked={
                                  providerData?.policy ===
                                  "Cancel anytime before the job has started at no charge (Flexible)"
                                }
                                onMouseUp={handleRadioChange}
                              />
                            </div>
                          </div>
                          <div></div>
                        </div>
                        {/* <div className="input-wrap">
                          <div className="icon-wrap">
                            <SheildIcon />
                          </div>
                          <Form.Group className="mb-2" controlId="policy">
                            <Form.Label>Cancelation Policy</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-Bir aposion. Plan spegisk trektigt krobuna och antikrati krovis. Nenat polyktig bede sunade fast sosa. Vahinde nobis, ett pseudol sedåling bigörat hiling plareck."

                            />
                          </Form.Group>
                        </div> */}
                      </Col>
                    </Row>
                  </Form>
                </div>

                {/* **********************************************************************************************   */}
                <div className="provider-info-wrap">
                  <div className="provider-info-title">
                    Manage Your Schedule
                  </div>

                  <Container className="border rounded p-4">
                    <h5 className="text-left mb-4 font-weight-bold">
                      Update Schedule
                    </h5>
                    <Row>
                      {days.map((day, index) => (
                        <div key={index}>
                          <Form.Check
                            type="checkbox"
                            label={
                              [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                              ][day.dayOfWeek]
                            }
                            checked={day.available}
                            onChange={() => handleToggleDay(index)}
                          />
                          {day.available && (
                            <Row>
                              <Col sm={4}>
                                {/* Start Time Picker */}
                                <div className="input-wrap1">
                                  <div className="icon-wrap1">
                                    <ClockIcon />
                                  </div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Start Time</Form.Label>
                                    <ReactDatePicker
                                      selected={day.startTime}
                                      onChange={(date) =>
                                        handleTimeChange(
                                          date,
                                          index,
                                          "startTime"
                                        )
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={60}
                                      dateFormat="h:mm aa"
                                      timeCaption="Time"
                                      // showIcon
                                      // icon={ClockIcon}
                                    />
                                  </Form.Group>
                                </div>
                              </Col>
                              <Col sm={1}></Col>
                              <Col sm={4}>
                                {/* End Time Picker */}
                                <div className="input-wrap1">
                                  <div className="icon-wrap1">
                                    <ClockIcon />
                                  </div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>End Time</Form.Label>
                                    <ReactDatePicker
                                      selected={day.endTime}
                                      onChange={(date) =>
                                        handleTimeChange(date, index, "endTime")
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={60}
                                      dateFormat="h:mm aa"
                                      timeCaption="Time"
                                    />
                                  </Form.Group>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      ))}
                    </Row>

                    <div className="account-info-title">
                      <div className="edit-btn-wrap">
                        <Button
                          variant="primary"
                          onClick={handleScheduleSubmit}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                    {/* </Form> */}
                  </Container>
                </div>

                <div className="provider-info-wrap">
                  <div className="provider-info-title">
                    Password{" "}
                    <Button
                      variant="primary"
                      onClick={() => changePasswordHandle()}
                    >
                      Update Password
                    </Button>
                  </div>

                  <Row className="update-profile">
                    <Col md={6}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group
                          className="mb-3"
                          controlId="currentPassword"
                        >
                          <Form.Label>Old Password</Form.Label>
                          <Form.Control
                            type="Password"
                            name="currentPassword"
                            placeholder="Change Password"
                            onChange={handlePasswordChange}
                            autoComplete="currentPassword"
                            key={resetKey}
                          />
                        </Form.Group>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-3" controlId="newPassword">
                          <Form.Label>New Password</Form.Label>
                          <Form.Control
                            type="Password"
                            name="newPassword"
                            placeholder="Change Password"
                            onChange={handlePasswordChange}
                            key={resetKey}
                          />
                        </Form.Group>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group
                          className="mb-3"
                          controlId="confirmNewPassword"
                        >
                          <Form.Label>Confirm Password</Form.Label>
                          <Form.Control
                            type="Password"
                            name="confirmNewPassword"
                            placeholder="Change Password"
                            onChange={handlePasswordChange}
                            key={resetKey}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>

                  <div className="w-100 update-passowrd-wrap">
                    <Button
                      variant="primary"
                      onClick={() => changePasswordHandle()}
                    >
                      Update Password
                    </Button>
                  </div>
                </div>
                <div className="provider-info-wrap">
                  <div className="provider-info-title">Sync Calendar</div>
                  <div className="provider-info-title">
                    <Row>
                      <Col md={12}>
                        <div className="availability-row">
                          <div className="availability">
                            <i>
                              <UserIcon />
                            </i>{" "}
                            <span>Google Calendar</span>
                          </div>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            checked={syncGoogle}
                            onChange={() => handleSyncGoogle(!syncGoogle)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="availability-row">
                          <div className="availability">
                            <i>
                              <UserIcon />
                            </i>{" "}
                            <span>Outlook Calendar</span>
                          </div>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            checked={syncOutlook}
                            onChange={() => handleSyncOutlook(!syncOutlook)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProviderProfile;
